import { BracketNode } from "model/Bracket/BracketGraph";
import { GapSvg, Svg } from "./styles";

export const createBracketLinePlaceholder = () => {
  return <Svg viewBox="0, 0, 100, 100" preserveAspectRatio="none" />;
};

export const createBracketLineGapPlaceholder = () => {
  return <GapSvg viewBox="0, 0, 100, 100" preserveAspectRatio="none" />;
};

export const createBracketLineStraight = () => {
  return (
    <Svg viewBox="0, 0, 100, 100" preserveAspectRatio="none">
      <polyline vectorEffect="non-scaling-stroke" points="0,50, 100,50" />
    </Svg>
  );
};

export const createBracketLineGap = () => {
  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <GapSvg viewBox="0, 0, 100, 100" preserveAspectRatio="none">
        <polyline
          vectorEffect="non-scaling-stroke"
          points="0,25, 15,25 15,50, 100,50 15,50 15,75 0,75"
        />
      </GapSvg>
    </div>
  );
};

export const createBracketLineFork = () => {
  return (
    <Svg viewBox="0, 0, 100, 100" preserveAspectRatio="none">
      <polyline
        vectorEffect="non-scaling-stroke"
        points="0,25, 50,25 50,50, 100,50 50,50 50,75 0,75"
      />
    </Svg>
  );
};

export const createBracketLineForkTop = () => {
  return (
    <Svg viewBox="0, 0, 100, 100" preserveAspectRatio="none">
      <polyline
        vectorEffect="non-scaling-stroke"
        points="0,25, 50,25 50,50, 100,5"
      />
    </Svg>
  );
};

export const createBracketLineForkBottom = () => {
  return (
    <Svg viewBox="0, 0, 100, 100" preserveAspectRatio="none">
      <polyline
        vectorEffect="non-scaling-stroke"
        points="100,50 50,50 50,75 0,75"
      />
    </Svg>
  );
};

export const createBracketLineGrandFinalVertical = () => {
  return (
    <Svg preserveAspectRatio="none" viewBox="0, 0, 2, 2">
      <polyline vectorEffect="non-scaling-stroke" points="1,0, 1,2" />
    </Svg>
  );
};

export const createBracketLineGrandFinalUpper = () => {
  return (
    <Svg viewBox="0, 0, 100, 100" preserveAspectRatio="none">
      <polyline vectorEffect="non-scaling-stroke" points="0,50, 50,50 50,100" />
    </Svg>
  );
};

export const createBracketLineGrandFinalInto = () => {
  return (
    <Svg viewBox="0, 0, 100, 100" preserveAspectRatio="none">
      <polyline
        vectorEffect="non-scaling-stroke"
        points="50,0, 50,100 50,50, 100,50"
      />
    </Svg>
  );
};

export const createBracketLineGrandFinalLower = () => {
  return (
    <Svg viewBox="0, 0, 100, 100" preserveAspectRatio="none">
      <polyline vectorEffect="non-scaling-stroke" points="0,50, 50,50 50,0" />
    </Svg>
  );
};

export const createBracketLine = (
  node: BracketNode | undefined,
  isSpaceColumn: boolean = false
) => {
  if (isSpaceColumn) {
    return !!node ? createBracketLineGap() : createBracketLineGapPlaceholder();
  }

  if (!node) {
    return createBracketLinePlaceholder();
  }

  // If lower and one source is seed or from upper we want a straight line
  if (
    node.isLower &&
    ((!!node.teamOneSource && !node.teamOneSource.isLower) ||
      (!!node.teamTwoSource && !node.teamTwoSource.isLower))
  ) {
    if (!!node.teamTwoSource) {
      return createBracketLineStraight();
    }
  }
  // Else requires a fork of somesort
  else {
    if (!!node.teamOneSource && !!node.teamTwoSource) {
      return createBracketLineFork();
    }

    if (!!node.teamOneSource) {
      return createBracketLineForkTop();
    }

    if (!!node.teamTwoSource) {
      return createBracketLineForkBottom();
    }
  }

  // Default - node has no sources, use blank placeholder svg
  return createBracketLinePlaceholder();
};
